import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const CertificateNationalityDetails = () => <OperatorRequestDetails />;

export default CertificateNationalityDetails;
